module.exports = __webpack_public_path__ + "static/media/cq_documento b.3d127911.svg";